export var LeadStatus;
(function (LeadStatus) {
    LeadStatus[LeadStatus["New"] = 1] = "New";
    LeadStatus[LeadStatus["Quotation"] = 2] = "Quotation";
    LeadStatus[LeadStatus["Signed"] = 3] = "Signed";
    LeadStatus[LeadStatus["Completed"] = 4] = "Completed";
    LeadStatus[LeadStatus["Remark"] = 5] = "Remark";
    LeadStatus[LeadStatus["Special"] = 6] = "Special";
    LeadStatus[LeadStatus["InReview"] = 7] = "InReview";
    LeadStatus[LeadStatus["Assign"] = 8] = "Assign";
    // Deprecated statuses - kept for backward compatibility
    LeadStatus[LeadStatus["ExpiredCompetition"] = 9] = "ExpiredCompetition";
    LeadStatus[LeadStatus["ExpiredIncorrectlyRegistered"] = 10] = "ExpiredIncorrectlyRegistered";
    LeadStatus[LeadStatus["ExpiredNotKnown"] = 11] = "ExpiredNotKnown";
    LeadStatus[LeadStatus["ExpiredPrice"] = 12] = "ExpiredPrice";
    LeadStatus[LeadStatus["ExpiredOrderViaOtherQuotation"] = 13] = "ExpiredOrderViaOtherQuotation";
    // New statuses
    LeadStatus[LeadStatus["InProgress"] = 14] = "InProgress";
    LeadStatus[LeadStatus["NoQuotationSubmitted"] = 15] = "NoQuotationSubmitted";
    LeadStatus[LeadStatus["LostQuotation"] = 16] = "LostQuotation";
    // Manually set by the sales agent after manual checks, once work is handed
    // toward planning (distinct from the automatic "Compleet"/Completed status).
    // No automatic trigger.
    LeadStatus[LeadStatus["AfgerondRichtingPlanning"] = 17] = "AfgerondRichtingPlanning";
})(LeadStatus || (LeadStatus = {}));
